export class ReadingInfo {
    constructor(public leolvasott: Set<string>, public korrigalt: Map<string, number>, 
        public metadata: Map<string, string>){
       
    }
}


// WEBPACK FOOTER //
// /Users/pkovacs/Documents/Development/ngsAlpha/ngs_alpha_ui/src/app/ngs-types/reading-info.ts